/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
export default {
  name: 'organization-connection-request-list',
  components: {},
  props: [],
  data () {
    return {
      connReqList:{},
      userLoading: false,
      submitted:false,
    }
  },
  computed: {
  ...mapGetters([
    'orgConnectionReqListGetters'
  ]),
  getconnReqListDetailsFun(){
    return this.connReqList = this.$store.getters.orgConnectionReqListGetters.data
  },
  },
  mounted () {
    this.getconnReqListDetailsFun
  },
  methods: {
  },
  watch:{
    getconnReqListDetailsFun(){
      return this.connReqList = this.$store.getters.orgConnectionReqListGetters.data
    },
  }
}